var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCallVideoOffi = function SvgCallVideoOffi(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    d: "m19.623 7.207 1.215-.527a.8.8 0 0 1 1.118.734v9.172a.8.8 0 0 1-.361.669.8.8 0 0 1-.757.065l-4.17-1.808v.944c0 .978-.793 1.772-1.77 1.772H8.602l1.6-1.6h4.695a.17.17 0 0 0 .17-.172v-2.148a.8.8 0 0 1 1.119-.749l4.17 1.808V8.633l-3.812 1.653 3.08-3.08zM3.096 18.077a1.77 1.77 0 0 1-1.056-1.62V7.544c0-.978.793-1.772 1.77-1.772h11.086q.232 0 .447.057L13.8 7.372h-10a.17.17 0 0 0-.17.172v8.912a.17.17 0 0 0 .17.172h.734l-1.45 1.45z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e91e63",
    d: "m4.687 20.443 14.89-14.89a.8.8 0 1 0-1.13-1.132L3.555 19.311a.801.801 0 0 0 1.13 1.132"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCallVideoOffi);
export default ForwardRef;